var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstaprofile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6332_28131)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint0_linear_6332_28131)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5486 5.3335H9.45522C7.18322 5.3335 5.33789 7.17883 5.33789 9.45083V14.5442C5.33789 16.8162 7.18322 18.6615 9.45522 18.6615H14.5486C16.8206 18.6615 18.6659 16.8162 18.6659 14.5442V9.45083C18.6659 7.17883 16.8206 5.3335 14.5486 5.3335ZM17.1779 14.5495C17.1779 16.0002 15.9992 17.1842 14.5432 17.1842H9.44989C7.99922 17.1842 6.81522 16.0055 6.81522 14.5495V9.45616C6.81522 8.0055 7.99389 6.8215 9.44989 6.8215H14.5432C15.9939 6.8215 17.1779 8.00016 17.1779 9.45616V14.5495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 8.59229C10.1225 8.59229 8.5918 10.123 8.5918 12.0003C8.5918 13.8776 10.1225 15.4083 11.9998 15.4083C13.8771 15.4083 15.4078 13.8776 15.4078 12.0003C15.4078 10.123 13.8771 8.59229 11.9998 8.59229ZM11.9998 14.0696C10.8585 14.0696 9.93046 13.1416 9.93046 12.0003C9.93046 10.859 10.8585 9.93095 11.9998 9.93095C13.1411 9.93095 14.0691 10.859 14.0691 12.0003C14.0691 13.1416 13.1411 14.0696 11.9998 14.0696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6669 8.96527C15.9809 8.91437 16.1941 8.61858 16.1432 8.3046C16.0923 7.99062 15.7966 7.77735 15.4826 7.82825C15.1686 7.87915 14.9553 8.17494 15.0062 8.48892C15.0571 8.8029 15.3529 9.01617 15.6669 8.96527Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6332_28131",
    x1: 2.86288,
    y1: 21.1371,
    x2: 19.9162,
    y2: 4.08379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0518459,
    stopColor: "#FEDB16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1381,
    stopColor: "#FEC125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2481,
    stopColor: "#FE983D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#FE5F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE2181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9000DC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6332_28131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaprofile);
export default __webpack_public_path__ + "static/media/instaprofile.4799b88fc4596287f66c4ab1b72f27df.svg";
export { ForwardRef as ReactComponent };